import React from 'react';
import { Link } from 'react-router-dom';
import { useAOS } from '../../hooks/useExternalLibs';
import { useLanguage } from '../../contexts/LanguageContext';

const GlobalSupplyChain = () => {
  // Initialize external libraries using custom hooks
  useAOS();
  
  // Get translation function
  const { t } = useLanguage();

  return (
    <div className="service-details-page">
      {/* Page Title */}
      <div className="page-title dark-background" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/Photo-Building/eid1.JPG)` }}>
        <div className="container position-relative">
          <h1>{t('globalSupplyChain.pageTitle')}</h1>
          <nav className="breadcrumbs">
            <ol>
              <li><Link to="/">{t('globalSupplyChain.breadcrumbHome')}</Link></li>
              <li><Link to="/">{t('globalSupplyChain.breadcrumbServices')}</Link></li>
              <li className="current">{t('globalSupplyChain.breadcrumbCurrent')}</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Service Details Section */}
      <section id="service-details" className="service-details section">
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="100">
              <div className="services-list">
                <Link to="/services/custom-manufacturing">{t('globalSupplyChain.customManufacturing')}</Link>
                <Link to="/services/technical-support">{t('globalSupplyChain.technicalSupport')}</Link>
                <Link to="/services/after-sales-service">{t('globalSupplyChain.afterSalesService')}</Link>
                <Link to="/services/quality-assurance">{t('globalSupplyChain.qualityAssurance')}</Link>
                <Link to="/services/research-development">{t('globalSupplyChain.researchDevelopment')}</Link>
                <Link to="/services/global-supply-chain" className="active">{t('globalSupplyChain.globalSupplyChain')}</Link>
              </div>
            </div>
            <div className="col-lg-8" data-aos="fade-up" data-aos-delay="200">
              <div className="service-content text-center">
                <img src={`${process.env.PUBLIC_URL}/assets/img/building/building-ekk.png`} alt="Global Supply Chain" className="img-fluid services-img mx-auto d-block" />
                <h3 className="text-center">{t('globalSupplyChain.title')}</h3>
                <p className="text-center">
                  {t('globalSupplyChain.description1')}
                </p>
                <p className="text-center">
                  {t('globalSupplyChain.description2')}
                </p>
                <h4 className="text-center">{t('globalSupplyChain.capabilitiesTitle')}</h4>
                <ul className="text-start">
                  {t('globalSupplyChain.capabilities').map((capability, index) => (
                    <li key={index}><i className="bi bi-check-circle"></i> <span>{capability}</span></li>
                  ))}
                </ul>
                
                <h4 className="text-center">{t('globalSupplyChain.distributionTitle')}</h4>
                <p className="text-center">
                  {t('globalSupplyChain.distributionDescription')}
                </p>
                
                <div className="row gy-4 mt-4">
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('globalSupplyChain.deliveryPerformance')}</h5>
                      <p>{t('globalSupplyChain.deliveryPerformanceDesc')}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('globalSupplyChain.globalReach')}</h5>
                      <p>{t('globalSupplyChain.globalReachDesc')}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('globalSupplyChain.inventoryManagement')}</h5>
                      <p>{t('globalSupplyChain.inventoryManagementDesc')}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('globalSupplyChain.logisticsPartners')}</h5>
                      <p>{t('globalSupplyChain.logisticsPartnersDesc')}</p>
                    </div>
                  </div>
                </div>
                
                <h4 className="text-center">{t('globalSupplyChain.technologyTitle')}</h4>
                <p className="text-center">
                  {t('globalSupplyChain.technologyDescription')}
                </p>
                
                <h4 className="text-center">{t('globalSupplyChain.sustainableTitle')}</h4>
                <p className="text-center">
                  {t('globalSupplyChain.sustainableDescription')}
                </p>
                
                <h4 className="text-center">{t('globalSupplyChain.customerIntegrationTitle')}</h4>
                <p className="text-center">
                  {t('globalSupplyChain.customerIntegrationDescription')}
                </p>
                
                <div className="text-center">
                  <Link to="/contact" className="btn btn-primary">{t('globalSupplyChain.inquireDelivery')}</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Related Services Section */}
      <section id="related-services" className="related-services section">
        <div className="container">
          <div className="section-title" data-aos="fade-up">
            <h2>{t('globalSupplyChain.relatedServicesTitle')}</h2>
            <p>{t('globalSupplyChain.relatedServicesDescription')}</p>
          </div>
          <div className="row gy-4">
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
              <div className="service-item position-relative">
                <div className="icon">
                  <i className="fa-solid fa-compass-drafting"></i>
                </div>
                <h3>{t('globalSupplyChain.afterSalesService')}</h3>
                <p>{t('globalSupplyChain.afterSalesServiceDesc')}</p>
                <Link to="/services/after-sales-service" className="readmore stretched-link">{t('globalSupplyChain.readMore')} <i className="bi bi-arrow-right"></i></Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
              <div className="service-item position-relative">
                <div className="icon">
                  <i className="fa-solid fa-mountain-city"></i>
                </div>
                <h3>{t('globalSupplyChain.customManufacturing')}</h3>
                <p>{t('globalSupplyChain.customManufacturingDesc')}</p>
                <Link to="/services/custom-manufacturing" className="readmore stretched-link">{t('globalSupplyChain.readMore')} <i className="bi bi-arrow-right"></i></Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
              <div className="service-item position-relative">
                <div className="icon">
                  <i className="fa-solid fa-arrow-up-from-ground-water"></i>
                </div>
                <h3>{t('globalSupplyChain.technicalSupport')}</h3>
                <p>{t('globalSupplyChain.technicalSupportDesc')}</p>
                <Link to="/services/technical-support" className="readmore stretched-link">{t('globalSupplyChain.readMore')} <i className="bi bi-arrow-right"></i></Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GlobalSupplyChain;